import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";
import { Button, ButtonGroup, Link } from "@mui/material";
import * as Routes from "routes";

const CustomButtonGroup = ({ licenced, displayProduct }: any) => {
  return (
    <div>
      <ButtonGroup
        variant="contained"
        aria-label="outlined primary button group"
        color="primary"
      >
        <Button
          LinkComponent={Link}
          href={`${Routes.dataDownload}?product=${displayProduct}&licenced=${licenced}`}
          startIcon={licenced ? <DownloadIcon /> : <EmailIcon />}

          disabled={!licenced}
        >
          {licenced ? "Download" : "Contact"}
        </Button>
        <Button
          color="primary"
          disabled={true}
          startIcon={<DownloadIcon />}
          onClick={() => {}}
        >
          SAMPLE
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default CustomButtonGroup;
